import $ from 'jquery'
import initPdfButtons from '../../js/utils/init-pdf-buttons'

// eslint-disable-next-line no-undef
const vars = bookingHub

$(document).on('click', '[data-bhub-cancel-booking]', function () {
  const $this = $(this)
  const id = $this.data('bhub-cancel-booking') * 1
  const canCancel = vars.user.canCancelBooking

  const title = canCancel
    ? vars.modal.cancelBooking.title
    : vars.modal.cancelBookingRequest.title
  const content = canCancel
    ? vars.modal.cancelBooking.content
    : vars.modal.cancelBookingRequest.content
  const button = canCancel
    ? vars.modal.cancelBooking.button
    : vars.modal.cancelBookingRequest.button

  const dialog = $.confirm({
    theme: 'bhub-dialog',
    closeIcon: true,
    closeIconClass: 'bhub-icons-close',
    draggable: false,
    backgroundDismiss: true,
    escapeKey: true,
    animateFromElement: false,
    animationSpeed: 300,
    animation: 'zoom',
    closeAnimation: 'zoom',
    useBootstrap: false,
    onContentReady: function () {
      this.$content
        .find('.bhub-framework-onload')
        .booking_hub_framework_reload_script()
    },
    content: content,
    title,
    buttons: {
      cancel: {
        text: vars.i18n.cancel,
        btnClass: 'bhub-button bhub-button--plain',
        action: function () {
          dialog.close()
        },
      },
      delete: {
        text: button,
        btnClass: 'bhub-button',
        action: function () {
          const form = $('.bhub-cancel-booking-reason-form')
          if (!form.valid()) {
            vars.notyf.error(vars.i18n.fillRequiredFields)
            return false
          }
          $.ajax({
            url: vars.ajaxUrl,
            method: 'POST',
            dataType: 'json',
            data: {
              action: 'bhub/bookings/status/cancel',
              _ajax_nonce: vars.nonce,
              form: form.serialize(),
              id,
            },
            beforeSend: () => {
              $this.bhubBlockButton()
            },
            success: (res) => {
              const { data, success } = res

              $this.parent().prepend(data.user_message)

              if (success) {
                $this.remove()
              }

              vars.notyf.success(data.message)
            },
            complete: () => {
              $this.bhubUnBlockButton()
            },
          })
          dialog.close()
        },
      },
    },
  })
})

const el = document.querySelector('.bhub-invoice')
if (el) {
  initPdfButtons(el)
}
